import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    dark: true,
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#ECBE04',
        secondary: '#111111',
        tertiary: '#333333',
        panel_primary: '#EAEAEA',
        btnColor: '#036037'
      }
    }
  }
})
